/** campaign: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "dragPlayhead": "Drag to move through the preview",
  "layoutNameQ": "Name for this layout",
  "layoutNameDefault": "{name} layout",
  "deleteIxQ": "Delete the interaction “{name}”?",
  "fewerSections": "The new layout has fewer sections: {n} item in the removed sections will be taken off. Continue? | The new layout has fewer sections: {n} items in the removed sections will be taken off. Continue?",
  "editLayoutTitle": "Edit Layout · {name}",
  "deleteLayoutQ": "Delete layout “{name}”? Campaigns that used it keep their sections.",
  "sectionN": "Section {n}",
  "nameSection": "Give section {n} a name.",
  "dragHint": "Drag onto a section's track, or click + to choose a section.",
  "noReady": "No ready content yet. Upload files or add apps on the",
  "page": "page.",
  "nSections": "{n} section | {n} sections",
  "custom": "custom",
  "previewHint": "Videos, images and apps play as on the player (sound off). Duration: {len} (longest section).",
  "selectSection": "Select section {name}",
  "layerN": "Layer {n}",
  "blackFor": "Black for {len}",
  "looped": "{len}, looped",
  "emptySections": "Empty: {names}. Every section needs content before the campaign can be published.",
  "inSection": "In section",
  "itemOf": "· item {i} of {n}",
  "fileLength": "File length {len}.",
  "unknown": "unknown",
  "addContent": "Add content",
  "addContentTo": "Add content to {section}",
  "addNothing": "No ready content matches.",
  "addToLabel": "Add to",
  "addN": "Add 1 item | Add {n} items",
  "addPick": "Select content to add",
  "loadingMore": "Loading more…",
  "shownOf": "{n} of {total}",
  "addedN": "Added {n} items to {section}",
  "app": "App",
  "video": "Video",
  "image": "Image",
  "contentFit": "Content fit",
  "contentFitHint": "How images and videos fill their sections. Each item can override it in its properties.",
  "fitPlayer": "Player's Display Settings",
  "fitPlayerShort": "player's setting",
  "itemFit": "Fit in its section",
  "fitCampaign": "Campaign default ({fit})",
  "addTo": "Add {name} to {section}",
  "addToPick": "Add {name} to a section",
  "addToWhich": "Add to section",
  "added": "Added “{name}” to {section}",
  "undo": "Undo",
  "itemsCount": "empty | 1 item | {n} items",
  "current": "Current section",
  "fullScreen": "Full screen",
  "ixDeleted": "Interaction deleted",
  "ixSaved": "Interaction saved · players playing this campaign update on their next sync",
  "gone": "This campaign no longer exists.",
  "editSections": "Edit sections",
  "newLayout": "New Layout",
  "enterName": "Enter a Campaign Name.",
  "savedAll": "Saved. Every player playing this campaign is being updated.",
  "savedDot": "Saved.",
  "trNone": "None",
  "trFade": "Fade",
  "trSlide": "Slide",
  "trFlip": "Flip",
  "leaveQ": "You have unsaved changes. Leave without saving?",
  "back": "Back to Content",
  "backPrev": "Back",
  "name": "Campaign Name",
  "unsaved": "Unsaved changes",
  "restrictAll": "Restrict when it plays, on all players",
  "restrictedAll": "Restricted on all players — change",
  "restrictionLocked": "🔒 Restriction",
  "restriction": "Restriction",
  "saveTitle": "Save (Ctrl+S)",
  "create": "Create Campaign",
  "saving": "Saving…",
  "savePublish": "Save & Publish",
  "publish": "Publish",
  "loading": "Loading…",
  "notSaved": "Not saved",
  "tabInfo": "Details",
  "tabContent": "Media",
  "tabInteractivity": "Interactivity",
  "ixIntro": "Tap a zone or hotspot — or press a remote key — while this campaign plays, to open content or a web page. Saved on their own (not with Save).",
  "newIx": "+ New interaction",
  "noIx": "No interactions yet.",
  "search": "Search",
  "searchContent": "Search content",
  "type": "Type",
  "all": "All",
  "images": "Images",
  "videos": "Videos",
  "apps": "Apps",
  "enterTransition": "Enter Transition",
  "transitionMs": "Transition (ms)",
  "itemTransition": "Enters with",
  "itemTransitionHint": "How this item comes in after the one before it in this section. Applies in this campaign only.",
  "defaultDuration": "Default Media Duration (in seconds)",
  "infoHint": "The whole screen enters with this transition when the campaign starts. Default duration applies to images and apps you add; videos play to their end unless shortened on the timeline.",
  "saveSectionsLayout": "Save sections as a layout",
  "preview": "Preview",
  "playhead": "Playhead",
  "editInPreview": "Edit {name}",
  "pausePreview": "Pause preview",
  "playPreview": "Play preview",
  "timeline": "Timeline",
  "timelineHint": "Drag to reorder · drag a block's right edge to change its duration · click for properties",
  "listHint": "Drag ⠿ to reorder or move between sections (press and hold on touch) · + Add content · click an item for its properties",
  "dragRow": "Drag to reorder or move to another section",
  "dropHere": "Drop here",
  "zoom": "Zoom",
  "viewAs": "Show as",
  "viewTimeline": "Timeline",
  "viewList": "List",
  "listSummary": "No items | 1 item · {len} | {n} items · {len}",
  "addingHere": "Adding here",
  "listEmpty": "Nothing here yet. Tap a section, then + on content above to add it here.",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "bottomLayer": "Bottom layer",
  "topLayer": "Top layer",
  "missingItem": "Missing item",
  "dragHere": "Drag content here",
  "contentEnded": "→ Content Ended",
  "loopOnHint": "Plays its items again until the campaign ends",
  "loopOffHint": "After its last item this section shows black until the campaign starts again",
  "loopOn": "⟳ Loop",
  "loopOff": "Loop off · black until the next pass",
  "audioTrack": "Audio Track",
  "audioTrackLabel": "♪ Audio Track",
  "noAudio": "No audio",
  "audioPlaylists": "Audio playlists",
  "audioFiles": "Audio files",
  "muteVideo": "Mute the sections' video sound",
  "uploadAudio": "Upload an audio file in Content to add background music.",
  "item": "Item",
  "itemProps": "Item Properties",
  "itemDuration": "Item Duration (seconds)",
  "playToEnd": "Play to the end",
  "prev": "‹ Previous",
  "next": "Next ›",
  "removeItem": "Remove Item",
  "close": "Close",
  "applyHint": "Changes apply to this campaign when you click Apply.",
  "layoutsHint": "Saved layouts can be picked for any campaign.",
  "layoutName": "Layout Name",
  "editLayoutNote": "Editing a saved layout doesn't change campaigns that already use it.",
  "cancel": "Cancel",
  "apply": "Apply",
  "createLayout": "Create Layout",
  "saveLayout": "Save Layout",
  "createUse": "Create & Use",
  "saveUse": "Save & Use",
  "save": "Save",
  "saved": "Saved"
};
const ar: typeof en = {
  "dragPlayhead": "اسحب للتنقل في المعاينة",
  "layoutNameQ": "اسم هذا التخطيط",
  "layoutNameDefault": "تخطيط {name}",
  "deleteIxQ": "حذف التفاعل «{name}»؟",
  "fewerSections": "التخطيط الجديد فيه أقسام أقل: لن تُزال أي عناصر. متابعة؟ | التخطيط الجديد فيه أقسام أقل: سيُزال عنصر واحد من الأقسام المحذوفة. متابعة؟ | التخطيط الجديد فيه أقسام أقل: سيُزال عنصران من الأقسام المحذوفة. متابعة؟ | التخطيط الجديد فيه أقسام أقل: ستُزال {n} عناصر من الأقسام المحذوفة. متابعة؟ | التخطيط الجديد فيه أقسام أقل: سيُزال {n} عنصرًا من الأقسام المحذوفة. متابعة؟ | التخطيط الجديد فيه أقسام أقل: سيُزال {n} عنصر من الأقسام المحذوفة. متابعة؟",
  "editLayoutTitle": "تعديل التخطيط · {name}",
  "deleteLayoutQ": "حذف التخطيط «{name}»؟ تحتفظ الحملات التي استخدمته بأقسامها.",
  "sectionN": "القسم {n}",
  "nameSection": "سمِّ القسم {n}.",
  "dragHint": "اسحب إلى مسار قسم، أو انقر + لاختيار القسم.",
  "noReady": "لا يوجد محتوى جاهز بعد. ارفع ملفات أو أضف تطبيقات في صفحة",
  "page": ".",
  "nSections": "لا أقسام | قسم واحد | قسمان | {n} أقسام | {n} قسمًا | {n} قسم",
  "custom": "مخصص",
  "previewHint": "تُعرض الفيديوهات والصور والتطبيقات كما على المشغل (دون صوت). المدة: {len} (أطول قسم).",
  "selectSection": "تحديد القسم {name}",
  "layerN": "الطبقة {n}",
  "blackFor": "أسود لمدة {len}",
  "looped": "{len}، مكرر",
  "emptySections": "فارغة: {names}. يحتاج كل قسم إلى محتوى قبل نشر الحملة.",
  "inSection": "في القسم",
  "itemOf": "· العنصر {i} من {n}",
  "fileLength": "طول الملف {len}.",
  "unknown": "غير معروف",
  "addContent": "إضافة محتوى",
  "addContentTo": "إضافة محتوى إلى {section}",
  "addNothing": "لا يوجد محتوى جاهز مطابق.",
  "addToLabel": "إضافة إلى",
  "addN": "إضافة عنصر واحد | إضافة {n} عناصر",
  "addPick": "اختر المحتوى المراد إضافته",
  "loadingMore": "جارٍ تحميل المزيد…",
  "shownOf": "{n} من {total}",
  "addedN": "تمت إضافة {n} عناصر إلى {section}",
  "app": "تطبيق",
  "video": "فيديو",
  "image": "صورة",
  "contentFit": "ملاءمة المحتوى",
  "contentFitHint": "كيف تملأ الصور ومقاطع الفيديو أقسامها. يمكن لكل عنصر تجاوزها من خصائصه.",
  "fitPlayer": "إعدادات العرض في المشغل",
  "fitPlayerShort": "إعداد المشغل",
  "itemFit": "الملاءمة في القسم",
  "fitCampaign": "افتراضي الحملة ({fit})",
  "addTo": "إضافة {name} إلى {section}",
  "addToPick": "إضافة {name} إلى قسم",
  "addToWhich": "إضافة إلى قسم",
  "added": "تمت إضافة “{name}” إلى {section}",
  "undo": "تراجع",
  "itemsCount": "فارغ | عنصر واحد | {n} عناصر",
  "current": "القسم الحالي",
  "fullScreen": "ملء الشاشة",
  "ixDeleted": "تم حذف التفاعل",
  "ixSaved": "تم حفظ التفاعل · تُحدَّث المشغلات التي تعرض هذه الحملة عند المزامنة التالية",
  "gone": "لم تعد هذه الحملة موجودة.",
  "editSections": "تعديل الأقسام",
  "newLayout": "تخطيط جديد",
  "enterName": "أدخل اسم الحملة.",
  "savedAll": "تم الحفظ. يجري تحديث كل مشغل يعرض هذه الحملة.",
  "savedDot": "تم الحفظ.",
  "trNone": "بلا",
  "trFade": "تلاشٍ",
  "trSlide": "انزلاق",
  "trFlip": "قلب",
  "leaveQ": "لديك تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟",
  "back": "العودة إلى المحتوى",
  "backPrev": "رجوع",
  "name": "اسم الحملة",
  "unsaved": "تغييرات غير محفوظة",
  "restrictAll": "تقييد وقت التشغيل على كل المشغلات",
  "restrictedAll": "مقيّدة على كل المشغلات — تغيير",
  "restrictionLocked": "🔒 قيد",
  "restriction": "قيد",
  "saveTitle": "حفظ (Ctrl+S)",
  "create": "إنشاء الحملة",
  "saving": "جارٍ الحفظ…",
  "savePublish": "حفظ ونشر",
  "publish": "نشر",
  "loading": "جارٍ التحميل…",
  "notSaved": "لم يُحفظ",
  "tabInfo": "التفاصيل",
  "tabContent": "الوسائط",
  "tabInteractivity": "التفاعل",
  "ixIntro": "المس منطقة أو نقطة تفاعل — أو اضغط زرًا في جهاز التحكم — أثناء عرض هذه الحملة لفتح محتوى أو صفحة ويب. تُحفظ وحدها (ليس مع زر الحفظ).",
  "newIx": "+ تفاعل جديد",
  "noIx": "لا توجد تفاعلات بعد.",
  "search": "بحث",
  "searchContent": "البحث في المحتوى",
  "type": "النوع",
  "all": "الكل",
  "images": "الصور",
  "videos": "الفيديوهات",
  "apps": "التطبيقات",
  "enterTransition": "انتقال الدخول",
  "transitionMs": "الانتقال (ملّي ثانية)",
  "itemTransition": "يظهر بانتقال",
  "itemTransitionHint": "طريقة ظهور هذا العنصر بعد العنصر السابق في هذا القسم. ينطبق على هذه الحملة فقط.",
  "defaultDuration": "مدة الوسائط الافتراضية (بالثواني)",
  "infoHint": "تدخل الشاشة كلها بهذا الانتقال عند بدء الحملة. تنطبق المدة الافتراضية على الصور والتطبيقات التي تضيفها؛ تُعرض الفيديوهات حتى نهايتها ما لم تُقصَّر على المخطط الزمني.",
  "saveSectionsLayout": "حفظ الأقسام كتخطيط",
  "preview": "معاينة",
  "playhead": "مؤشر التشغيل",
  "editInPreview": "تعديل {name}",
  "pausePreview": "إيقاف المعاينة مؤقتًا",
  "playPreview": "تشغيل المعاينة",
  "timeline": "المخطط الزمني",
  "timelineHint": "اسحب لإعادة الترتيب · اسحب الحافة اليمنى للكتلة لتغيير مدتها · انقر لعرض الخصائص",
  "listHint": "اسحب ⠿ لإعادة الترتيب أو النقل بين الأقسام (اضغط مطولاً على شاشات اللمس) · + إضافة محتوى · انقر على عنصر لعرض خصائصه",
  "dragRow": "اسحب لإعادة الترتيب أو النقل إلى قسم آخر",
  "dropHere": "أفلت هنا",
  "zoom": "تكبير",
  "viewAs": "العرض",
  "viewTimeline": "المخطط الزمني",
  "viewList": "قائمة",
  "listSummary": "لا عناصر | عنصر واحد · {len} | {n} عناصر · {len}",
  "addingHere": "الإضافة هنا",
  "listEmpty": "لا شيء هنا بعد. اختر قسمًا ثم اضغط + على المحتوى أعلاه لإضافته هنا.",
  "moveUp": "تحريك {name} لأعلى",
  "moveDown": "تحريك {name} لأسفل",
  "bottomLayer": "الطبقة السفلى",
  "topLayer": "الطبقة العليا",
  "missingItem": "عنصر مفقود",
  "dragHere": "اسحب المحتوى إلى هنا",
  "contentEnded": "← انتهى المحتوى",
  "loopOnHint": "يعيد تشغيل عناصره حتى تنتهي الحملة",
  "loopOffHint": "بعد آخر عنصر يعرض هذا القسم شاشة سوداء حتى تبدأ الحملة من جديد",
  "loopOn": "⟳ تكرار",
  "loopOff": "التكرار متوقف · أسود حتى الدورة التالية",
  "audioTrack": "المسار الصوتي",
  "audioTrackLabel": "♪ المسار الصوتي",
  "noAudio": "بلا صوت",
  "audioPlaylists": "قوائم تشغيل صوتية",
  "audioFiles": "ملفات صوتية",
  "muteVideo": "كتم صوت فيديوهات الأقسام",
  "uploadAudio": "ارفع ملفًا صوتيًا في المحتوى لإضافة موسيقى خلفية.",
  "item": "عنصر",
  "itemProps": "خصائص العنصر",
  "itemDuration": "مدة العنصر (بالثواني)",
  "playToEnd": "تشغيل حتى النهاية",
  "prev": "‹ السابق",
  "next": "التالي ›",
  "removeItem": "إزالة العنصر",
  "close": "إغلاق",
  "applyHint": "تُطبَّق التغييرات على هذه الحملة عند النقر على تطبيق.",
  "layoutsHint": "يمكن اختيار التخطيطات المحفوظة لأي حملة.",
  "layoutName": "اسم التخطيط",
  "editLayoutNote": "تعديل تخطيط محفوظ لا يغيّر الحملات التي تستخدمه بالفعل.",
  "cancel": "إلغاء",
  "apply": "تطبيق",
  "createLayout": "إنشاء تخطيط",
  "saveLayout": "حفظ التخطيط",
  "createUse": "إنشاء واستخدام",
  "saveUse": "حفظ واستخدام",
  "save": "حفظ",
  "saved": "محفوظ"
};
export default { en, ar };
